import React,{useEffect,useRef,useState} from 'react';
import CustomerProfileSection from './CustomerProfileSection';
import {getMarketingPreferences,saveMarketingPreference} from '../../api/marketingApi';
import MarketingDialog from '../marketing/MarketingDialog';
import Button from '../ui/Button';

export default function MarketingPreferences({token}) {
  const [state,setState]=useState(null),[error,setError]=useState(''),[busy,setBusy]=useState(false);
  const [pendingChannel,setPendingChannel]=useState(null);
  const currentToken=useRef(token);currentToken.current=token;
  useEffect(()=>{
    const controller=new AbortController();let active=true;
    setState(null);setError('');setBusy(false);setPendingChannel(null);
    if(token) getMarketingPreferences(token,controller.signal).then(data=>{
      if(active)setState({token,data});
    }).catch(()=>{if(active)setError('Preferenze non disponibili. Ricarica la pagina per riprovare.');});
    return()=>{active=false;controller.abort();};
  },[token]);
  const data=state?.token===token?state.data:null;
  async function save(channel,enabled) {
    const session=token;setBusy(true);setError('');
    try {
      const result=await saveMarketingPreference(session,{channel,enabled,
        revision:data.preferences[channel].revision,noticeVersion:data.notice.version});
      if(currentToken.current===session)setState({token:session,data:result});
    } catch(e) {if(currentToken.current===session)setError(e.message);}
    finally {if(currentToken.current===session)setBusy(false);}
  }
  return <CustomerProfileSection title="Comunicazioni commerciali facoltative">
    <div className="prf-body">
      <p>Le preferenze marketing sono separate dalle comunicazioni necessarie al servizio e dal permesso del dispositivo per le notifiche.</p>
      {!token?<p>Accedi per gestire le preferenze.</p>:!data&&!error?<p>Caricamento preferenze…</p>:null}
      {data&&<>
        {!data.notice.approved&&<p>Attivazione non disponibile: informativa marketing in attesa di pubblicazione e collaudo. Puoi revocare una preferenza già attiva.</p>}
        <p><a href={data.notice.approved?data.notice.url:(data.notice.privacyUrl||'https://www.stirup.it/privacy.html')} target="_blank" rel="noopener noreferrer">{data.notice.approved?'Informativa marketing':'Informativa privacy attuale'}</a></p>
        {['email','push'].map(channel=><div key={channel}>
          <label><input type="checkbox" checked={data.preferences[channel].enabled}
            disabled={busy||(!data.notice.approved&&!data.preferences[channel].enabled)}
            onChange={e=>e.target.checked?save(channel,true):setPendingChannel(channel)}/>
            {channel==='email'?'Marketing via email':'Marketing via push'}</label>
        </div>)}
        <p>Le scelte vengono salvate sul tuo account. Puoi revocarle qui senza costi; le email commerciali prevedono anche un collegamento di disiscrizione.</p>
      </>}
      {error&&<p role="alert">{error}</p>}
      <MarketingDialog open={!!data&&!!pendingChannel} title="Vuoi rinunciare alle nostre offerte?"
        closeLabel="Mantieni attive" onClose={()=>setPendingChannel(null)}
        primary={<Button onClick={()=>{const channel=pendingChannel;setPendingChannel(null);save(channel,false);}}>Disattiva</Button>}>
        <p>Disattivando questa preferenza non riceverai più {pendingChannel==='email'?'via email':'tramite notifiche push'} novità, sconti e offerte di StirUp. Potrai continuare a utilizzare tutti i servizi e riattivare le comunicazioni quando vuoi.</p>
      </MarketingDialog>
    </div>
  </CustomerProfileSection>;
}
